import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "w-lg-900px bg-white rounded shadow-sm p-10 mx-auto row" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-5 pt-50\" style=\"margin-top:10%;\"><div class=\"mb-6\"><img alt=\"Logo\" src=\"media/logos/logo.png\" class=\"h-50px\"></div><h2 class=\"text-dark mt-3\"> Skills for Industry Competitiveness and Innovation Program (SICIP) </h2><div><p class=\"mb-0\">Probashi Kalyan Bhaban (Level-16)</p><p>71-72 Old Elephant Road, Eskaton Garden, Dhaka-1000.</p><div style=\"margin-top:50%;\"></div></div></div>", 1)
const _hoisted_3 = { class: "col-md-7" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-10" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-dark mb-3" }, "Registration")
], -1)
const _hoisted_5 = { class: "card mb-5 mb-xl-10" }
const _hoisted_6 = {
  id: "employee_information",
  class: "collapse show"
}
const _hoisted_7 = { class: "collapse show" }
const _hoisted_8 = { class: "card-body border-top p-9" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-3" }, "Register as a Trainee")
], -1)
const _hoisted_10 = { class: "row mt-3" }
const _hoisted_11 = { class: "col-md-12" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Name", -1)
const _hoisted_13 = { class: "row mt-3" }
const _hoisted_14 = { class: "col-md-12" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Email")
], -1)
const _hoisted_16 = { class: "row mt-3" }
const _hoisted_17 = { class: "col-md-12" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Mobile")
], -1)
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = ["data-kt-indicator"]
const _hoisted_21 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_22 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_OTP = _resolveComponent("OTP")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.showTraineeForm == true)
        ? (_openBlock(), _createBlock(_component_Form, {
            key: 0,
            onSubmit: _cache[3] || (_cache[3] = ($event: any) => (_ctx.formSubmit())),
            class: "form",
            "validation-schema": _ctx.AssociationSchema
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _hoisted_9,
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _hoisted_12,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.trainee.name,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.trainee.name) = $event)),
                            type: "text",
                            name: "name",
                            class: "form-control form-control-lg"
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "name",
                            class: "fv-plugins-message-container invalid-feedback"
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _hoisted_15,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.trainee.email,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.trainee.email) = $event)),
                            name: "email",
                            class: "form-control form-control-lg",
                            value: ""
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "email",
                            class: "fv-plugins-message-container invalid-feedback"
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _hoisted_18,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.trainee.mobile,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.trainee.mobile) = $event)),
                            name: "mobile",
                            class: "form-control form-control-lg",
                            value: ""
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "mobile",
                            class: "fv-plugins-message-container invalid-feedback"
                          })
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("button", {
                  "data-kt-indicator": _ctx.loading ? 'on' : null,
                  class: "btn btn-lg btn-primary w-100 mb-5",
                  type: "submit"
                }, [
                  (!_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, " Continue "))
                    : _createCommentVNode("", true),
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                        _createTextVNode(" Please wait... "),
                        _hoisted_23
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_20)
              ])
            ]),
            _: 1
          }, 8, ["validation-schema"]))
        : _createCommentVNode("", true),
      (_ctx.showOtpForm == true)
        ? (_openBlock(), _createBlock(_component_OTP, {
            key: 1,
            trainee_name: _ctx.trainee_name,
            trainee_mobile: _ctx.trainee_mobile,
            trainee_email: _ctx.trainee_email,
            otp: _ctx.otp,
            "widget-classes": "card-xl-stretch mb-5 mb-xl-8"
          }, null, 8, ["trainee_name", "trainee_mobile", "trainee_email", "otp"]))
        : _createCommentVNode("", true)
    ])
  ]))
}